import React from "react";
import TargetBudgetRow from "./TargetBudgetRow";
import { Col, Row } from "antd";
import _ from "i18n";
import { connect } from "react-redux";

const TargetBudget = ({ budgetManagement, isRealized }) => {

  const { budgetPerMonth, globalBudget, lastBudgetPerMonth, lastMonthlyPremiumBudgetPerMonth } = budgetManagement;
  const registrantsCountArray = lastMonthlyPremiumBudgetPerMonth.map(item => item.registrantsCount);


  return (
    <div className={'target-budget mr-3'} style={{ width: (budgetManagement.appType === 'monthly_premium' && isRealized == false) ? '360px' : '220px' }}>
      <fieldset className={'target-budget-fieldset'}>
        {isRealized ? <legend
          className={'my-legend'}>{_('REALIZED_BUDGET')} {budgetManagement.year - 1}</legend>
          : <legend
            className={'my-legend'}>{_('TARGET_BUDGET')} {budgetManagement.year}</legend>
        }
        <div className={'target-budget-content'}>
          <Row className={`target-budget-first-row ${budgetManagement.followUp.length > 0 || budgetManagement.appType === 'all' || isRealized ? 'px-3' : 'px-3'}`}>
            <Col span={6}>{(budgetManagement.appType === 'monthly_premium' && isRealized === false) ? _("NEW_REGISTRANTS") : _('REGISTERED')}</Col>
            {(budgetManagement.appType === 'monthly_premium' && isRealized === false) &&
              <Col span={5}>{_("FORMER_REGISTRANTS")}</Col>
            }
            {(budgetManagement.appType === 'monthly_premium' && isRealized === false) &&
              <Col span={5}>{_("TOTAL_REGISTRED")}</Col>}
            <Col span={(budgetManagement.appType === 'monthly_premium' && isRealized === false) ? 6 : 14}>{_('INCOME')}</Col>

          </Row>
          {isRealized && lastBudgetPerMonth.map(({
            registrantsCount,
            totalHTVA
          }, index) => (
            <React.Fragment>
              <TargetBudgetRow isRealized={isRealized}
                registrantsCount={registrantsCount}
                globalBudget={globalBudget}
                totalHTVA={totalHTVA} index={index}
                style={
                  index % 2 === 0
                    ? { backgroundColor: "#FAFBFB" }
                    : { backgroundColor: "#F8F9FA" }
                }
                key={index}
              />
            </React.Fragment>
          ))}
          {(budgetManagement.appType !== 'monthly_premium') && !isRealized &&
            budgetPerMonth.map(({ registrantsCount, totalHTVA }, index) => (
              <React.Fragment>
                <TargetBudgetRow isRealized={isRealized}
                  registrantsCount={registrantsCount}
                  totalHTVA={totalHTVA} index={index}
                  style={
                    index % 2 === 0
                      ? { backgroundColor: "#FAFBFB" }
                      : { backgroundColor: "#F8F9FA" }
                  }
                  key={index}
                />
              </React.Fragment>
            ))
          }
          {!isRealized && budgetManagement.appType === 'monthly_premium' &&
            budgetPerMonth.map(({ registrantsCount, totalHTVA }, index) => (
              <React.Fragment>
                <TargetBudgetRow isRealized={isRealized}
                  registrantsCount={registrantsCount}
                  totalHTVA={totalHTVA} index={index}
                  MPregistrantsCount={registrantsCountArray}
                  style={
                    index % 2 === 0
                      ? { backgroundColor: "#FAFBFB" }
                      : { backgroundColor: "#F8F9FA" }
                  }
                  key={index}
                />
              </React.Fragment>
            ))
          }
        </div>
      </fieldset>
    </div>

  );

};

const mapStateToProps = state => ({
  budgetManagement: state.budgetManagement,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TargetBudget);



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/BudgetManagement/TargetBudget.js